import { render, staticRenderFns } from "./TestbankResultCorrectTable.vue?vue&type=template&id=1ad607b4&scoped=true&"
import script from "./TestbankResultCorrectTable.vue?vue&type=script&lang=js&"
export * from "./TestbankResultCorrectTable.vue?vue&type=script&lang=js&"
import style0 from "./TestbankResultCorrectTable.vue?vue&type=style&index=0&id=1ad607b4&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad607b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ad607b4')) {
      api.createRecord('1ad607b4', component.options)
    } else {
      api.reload('1ad607b4', component.options)
    }
    module.hot.accept("./TestbankResultCorrectTable.vue?vue&type=template&id=1ad607b4&scoped=true&", function () {
      api.rerender('1ad607b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Testbank/Result/TestbankResultCorrectTable.vue"
export default component.exports